import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { ToursService } from 'src/app/_services/tours.service';
import { ModalPasajeroConfirmadoComponent } from '../modal-pasajero-confirmado/modal-pasajero-confirmado.component';
import { ModalPasajeroEliminadoComponent } from '../modal-pasajero-eliminado/modal-pasajero-eliminado.component';
import { PasajeroReservadoComponent } from '../pasajero-reservado/pasajero-reservado.component';

@Component({
  selector: 'app-tour-agencias-reservados',
  templateUrl: './tour-agencias-reservados.component.html',
  styleUrls: ['./tour-agencias-reservados.component.css']
})
export class TourAgenciasReservadosComponent implements OnInit, OnDestroy  {

  idPaquete: Number;
  idPasajero: Number;
  idAgencia: Number;
  listaReservaciones = [];
  idReservacion: String;
  agenciaDatos = [];
  cantidadReservaciones: number;
  subscription: Subscription;
  subscriptionAg: Subscription;
  subscriptionPlanilla: Subscription;
  idPaquetePasajero: Number;
  filtered: Object[];
  listapasajeros = [];
  form: FormGroup;
  pasajeros = [];

  constructor(
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      search: [''],     
    });


    this.subscription = this.tourservice.paqueteReservadoPasajero.subscribe(result => {
      this.idPaquetePasajero = result;
    });

    this.subscriptionPlanilla = this.tourservice.pasajeroReservado.subscribe(result => {
      this.idPasajero = result;
    });

    this.subscriptionAg = this.tourservice.agenciaReserva.subscribe(result => {
      this.idAgencia = result;
    });

    this.agenciasTour();
    //this.listadoPasajeros();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionAg.unsubscribe();
    this.subscriptionPlanilla.unsubscribe();
  }

  //*** Modal de pasajero confirmado (luego de aprobar todos los pasajeros de una reservacion)
  openModalPasajerosConfirmados() {
    const modalRef = this.modalService.open(ModalPasajeroConfirmadoComponent, { 
      centered: true,  
      backdrop:'static',      
    });  
    this.aceptarTodosPasajeros();
  }
  
   //*** Modal de pasajero confirmado (luego de aprobarlo en su reservacion)
  openModalPasajeroConfirmado(id_pasajero) {
    const modalRef = this.modalService.open(ModalPasajeroConfirmadoComponent, { 
      centered: true,  
      backdrop:'static',      
    });  
    this.idPasajero = id_pasajero;
    this.tourservice.changePasajeroId(this.idPasajero);
    this.aceptarPasajero();
  }

   //*** Modal de pasajero eliminado (luego de eliminarlo en su reservacion)
  openModalPasajeroeliminado(id_pasajero) {
    const modalRef = this.modalService.open(ModalPasajeroEliminadoComponent, { 
      centered: true,  
      backdrop:'static',      
    });     
    this.idPasajero = id_pasajero;
    //this.tourservice.changePasajeroId(this.idPasajero);
    this.cancelarPasajero(id_pasajero);   
  }

  verPlanilla(id_pasajero) {
    this.idPasajero = id_pasajero;
    this.tourservice.changePasajeroId(this.idPasajero);
    //console.log("el pasajero que se toco es:  "+id_pasajero);
    this.router.navigate(['/admin/pasajero-reservado'],  { queryParams: { idPasajero: this.idPasajero } });
  }

  agenciasTour(){  
    this.listaReservaciones = [];
    this.agenciasService.agenciasTour(this.idAgencia, this.idPaquetePasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          console.log(data.body);
          this.cantidadReservaciones = data.body.length;
          this.listaReservaciones = data.body;
          this.agenciaDatos =  this.listaReservaciones[0].id_agencia;
          this.idReservacion = this.listaReservaciones[0].id;
        }
        this.listaReservaciones.forEach(reservacion => {
          var pass = reservacion.pasajeros;
          pass.forEach(pasajero => {
            this.listapasajeros.push(pasajero);
          });
        });
        this.filtered = this.listapasajeros;

        //console.log("cantidad de reservaciones:  " + this.cantidadReservaciones);
        //console.log("la agencia es:  " + this.agenciaDatos);  
        //console.log("la reservacion es:  " + this.idReservacion);     
        //console.log(this.listaReservaciones); 
        //console.log(this.listapasajeros);  
      }    
    });    
  }

  listadoPasajeros(){
    this.pasajeros = [];
    this.agenciasService.pasajerosTour(this.idAgencia, this.idPaquetePasajero, 1).subscribe(data => {
      if(data instanceof HttpResponse){
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.pasajeros = data.body;
          //this.filtered = data.body; console.log(this.filtered );
        }
      }
    })
  }

  aceptarPasajero(){
    this.agenciasService.aprobarPasajero(this.idPasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log('pasajero aceptado ' + this.idPasajero + ' ' + data.body.code);

          //*cambiar el estado de la reservacion a la que pertenece el pasajero, de 1 a 2 (confirmada)
          /* this.agenciasService.confirmarReservacion(this.idReservacion).subscribe(data => {
            if(data instanceof HttpResponse){
              if(data.body !== null && data.body !== undefined && data.body !== ''){
                console.log('reservacion confirmada ' + this.idReservacion + ' ' + data.body.code);
              }
              //*** recargar la informacion de las agencias  '/admin/tours-agencias-reservados' 
              this.redirectTo(this.router.url);  
            }
          }); */
          //*** recargar la informacion de las agencias  '/admin/tours-agencias-reservados' 
          this.redirectTo(this.router.url);
        }
      }
    });
    
  }

  aceptarTodosPasajeros(){    
    var todos=[];
    for(let i=0; i<this.listapasajeros.length; i++){
      if(this.listapasajeros[i].estado===1){
        todos.push(this.listapasajeros[i].id);
      }        
    }
    this.agenciasService.aprobarTodosPasajeros(todos).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log('pasajeros aceptados ' + this.idReservacion + ' ook' );

          //*cambiar el estado de la reservacion a la que pertenece el pasajero, de 1 a 2 (confirmada)
          /* this.agenciasService.confirmarReservacion(this.idReservacion).subscribe(data => {
            if(data instanceof HttpResponse){
              if(data.body !== null && data.body !== undefined && data.body !== ''){
                console.log('reservacion confirmada ' + this.idReservacion + ' ' + data.body.code);
              }
              //*** recargar la informacion de las agencias  '/admin/tours-agencias-reservados' 
              this.redirectTo(this.router.url);  
            }
          }); */
          //*** recargar la informacion de las agencias  '/admin/tours-agencias-reservados'
          this.redirectTo(this.router.url); 
        }
      }
    });    
  }

  cancelarPasajero(id_pasajero){
    this.agenciasService.cancelarPasajero(id_pasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log('pasajero cancelado ' + id_pasajero + ' ');
        }
        //*** recargar la informacion de las agencias  '/admin/tours-agencias-reservados' 
        this.redirectTo(this.router.url); 
      }
    });
     
  }

  onSubmit() { 
    var value = this.f.search.value;
    var recibido = [];
    if(value === ''){
      this.redirectTo(this.router.url); 
    }else {
      recibido = this.listapasajeros.filter(pass => 
        pass.numero_documento == value); 
      if(recibido.length === 0) {
        recibido = this.listapasajeros.filter(pass => 
          pass.nombre_pasajero === value); 
      } 
      this.filtered = recibido;
      //console.log(this.filtered);
    }
  }
  
  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }

  get f() { 
    return this.form.controls; 
  }

}
